import Main from "components/Main/Main";
import React, { useLayoutEffect } from "react";
import { ToastContainer } from "react-toastify";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { useWeb3React } from "@web3-react/core";
import WalletUnlock from "components/WalletUnlock/WalletUnlock";
import EthStore from "stores/EthStore";
import GovernanceStore from "stores/GovernanceStore";
import UserStore from "stores/UserStore";
import VaultStore from "stores/VaultStore";
import Modal from "react-modal";
import { useEagerConnect, useInactiveListener } from "hooks/web3";
import RouterStore from "stores/RouterStore";
import NFTStore from "stores/NFTStore";
Modal.setAppElement("#root");

function App() {
  const { account, library } = useWeb3React();

  useLayoutEffect(() => {
    (async () => {
      if (library) {
        const { name: networkName } = await library.getNetwork();
        EthStore.changeNetwork(networkName);
        if (account) {
          await EthStore.initialize(account, library);
          VaultStore.initializeContract(networkName);
          RouterStore.initializeContract(networkName);
          GovernanceStore.initializeContract(networkName);
          await VaultStore.fetchAllPoolData();
          UserStore.initialize();
          RouterStore.initialize();
          await NFTStore.initialize(networkName);
        }
      }
    })();
  }, [account, library]);

  const triedEager = useEagerConnect();
  useInactiveListener(!triedEager);

  return (
    <div className="app">
      <WalletUnlock>
        <Main />
        <ToastContainer />
      </WalletUnlock>
    </div>
  );
}

export default App;
